import { createContext } from "react";

export const VenueContext = createContext();
